import { defineStore } from "pinia";
import { ref } from "vue";
// import { useCldURLs } from "~/constants/apiv2.urls";
// import { CLD_ENV } from "~~/constants/env";

export const useShippingStore = defineStore("shipping", () => {
  const nuxtApp = useNuxtApp();

  // Booked shipping fee, VAT-included (LIGNES_V.TOT_NET_TI of the shipping line); 0 until booked.
  const shippingCost = ref(0);
  const isShippingCostAdded = ref();
  const orderPreparation = ref();
  const upsEstimation = ref(null);
  const upsEstimationLoading = ref(false);

  // The fee the customer actually pays for the already-booked shipping line — regime-correct TTC.
  // Any failure falls back to 0 so the deliverables payable total never turns NaN.
  const GetShippingCostValue = async () => {
    try {
      const url = useCldURLs[CLD_ENV].shipping.get_shipping_cost_value;
      const { data } = await useFetchApi(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      shippingCost.value = data.value?.status ? Number(data.value.data) || 0 : 0;
    } catch (err) {
      shippingCost.value = 0;
    }
  };

  const CheckPresenceOfShippingCost = async () => {
    const url = useCldURLs[CLD_ENV].shipping.check_shipping_cost;
    const { data } = await useFetchApi(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (data.value) {
      isShippingCostAdded.value = data.value.data;
      if (isShippingCostAdded.value) {
        await GetShippingCostValue();
      }
    }
  };

  const AddShippingCost = async () => {
    const url = useCldURLs[CLD_ENV].shipping.add_shipping_cost;

    const { data } = await useFetchApi(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    isShippingCostAdded.value = data.value.data;
    if (isShippingCostAdded.value) {
      await GetShippingCostValue();
    }
  };

  // Delivery-option pricing: { mode: "flat_fee" } keeps the EXW/CIF selector as-is;
  // { mode: "ups_rates", rates: [...] } unlocks the Express option. Any failure falls
  // back to null so the flat-fee selector is never blocked.
  const GetUpsEstimation = async () => {
    upsEstimationLoading.value = true;
    try {
      const url = useCldURLs[CLD_ENV].shipping.get_ups_estimation;
      const { data } = await useFetchApi(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      upsEstimation.value = data.value?.status ? data.value.data : null;
    } catch (err) {
      upsEstimation.value = null;
    } finally {
      upsEstimationLoading.value = false;
    }
  };

  const triggerOrderPreparation = async ({
    iterm,
    franco,
    selectedShippingOption,
  }) => {
  
    const url = useCldURLs[CLD_ENV].shipping.trigger_order_preparation;

    const { data } = await useFetchApi(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: {
        iterm,
        franco,
        selectedShippingOption,
      },
    });
    orderPreparation.value = data.value;
    isShippingCostAdded.value = data.value.status
    if (isShippingCostAdded.value) {
      await GetShippingCostValue();
    }
  };

  return {
    shippingCost,
    isShippingCostAdded,
    AddShippingCost,
    CheckPresenceOfShippingCost,
    GetShippingCostValue,
    triggerOrderPreparation,
    orderPreparation,
    upsEstimation,
    upsEstimationLoading,
    GetUpsEstimation,
  };
});
